import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

export type UserMode = 'personal' | 'coaching'

interface UserModeState {
  mode: UserMode
  setMode: (mode: UserMode) => void
  // Set by the invite button in coaching mode's tab bar; /coaching opens the invite form.
  inviteRequested: boolean
  requestInvite: (on: boolean) => void
}

export const useUserMode = create<UserModeState>()(
  persist(
    (set) => ({
      mode: 'personal',
      setMode: (mode) => set({ mode }),
      inviteRequested: false,
      requestInvite: (inviteRequested) => set({ inviteRequested }),
    }),
    {
      name: 'goaltree-user-mode',
      storage: createJSONStorage(() => localStorage),
      partialize: (s) => ({ mode: s.mode }),
    },
  ),
)

// Before first paint, like the accent: no flash of the personal accent on reload.
if (typeof document !== 'undefined' && useUserMode.getState().mode === 'coaching')
  document.documentElement.classList.add('coaching')
